export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/book_ebook_marketing.a550d63.svg";